import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

export function VisitTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    const t = setTimeout(() => { api.post("/track", { path: pathname }).catch(() => {}); }, 300);
    return () => clearTimeout(t);
  }, [pathname]);
  return null;
}

export default VisitTracker;
